import { Card, Form, Input, Select, Popconfirm } from 'antd';
import { DebouncedFunc } from 'lodash';
import React, { useEffect } from 'react';
import moment from 'moment';
import { DeleteOutlined, CopyOutlined } from '@ant-design/icons';

export function createId() {
  return `${moment(new Date()).valueOf().toString()}`;
}
type IndexProps = {
  noSource?: boolean;
  word: API.Word;
  workerVersions: API.SelectOption[];
  handleWordsChange: DebouncedFunc<(value: API.Word) => void>;
  copyWord: (word: API.Word) => void;
  deleteWord: (wordId: string) => void;
}

const Index: React.FC<IndexProps> = ({ word, handleWordsChange, copyWord, deleteWord, noSource = false, workerVersions }) => {
  const [form] = Form.useForm()
  const onValuesChange = (changedValues: any, values: any) => {
    handleWordsChange({ ...values, id: word.id, source: word.source });
  }

  useEffect(() => {
    form.setFieldsValue(word);
  }, [word]);

  const handleSourceChange = (value: string) => {
    handleWordsChange({ ...form.getFieldsValue(), id: word.id, source: value });
  }

  const title = <Input value={word.source} disabled={word.source === 'default'} onChange={(e) => handleSourceChange(e.target.value)} placeholder="请输入笔记标题" />
  let  p = {};
  if (!noSource) p = { title };
  
  return <Card
    { ...p }
    style={{ width: '100%', boxShadow: '2px 2px 8px rgba(0, 0, 0, 0.3)' }}
    actions={[
      <Popconfirm title="您确定删除该项吗？" onConfirm={() => deleteWord(word.id)}>
        <DeleteOutlined />
      </Popconfirm>,
      <Popconfirm title="您确定复制该项吗？" onConfirm={() => copyWord({ ...word, source: word.source + '复制', id: createId() })}>
        <CopyOutlined />
      </Popconfirm>,
    ]}
  >
    <Form
      name="basic"
      form={form}
      labelCol={{ span: 6 }}
      wrapperCol={{ span: 18 }}
      initialValues={{ remember: true }}
      onValuesChange={onValuesChange}
      autoComplete="off"
      // layout={'vertical'}
    >
      <Form.Item
        label="打招呼语"
        name="greeting"
        rules={[{ required: true, message: '请输入打招呼文字' }]}
      >
        <Input.TextArea autoSize={{ minRows: 3 }} placeholder="请输入打招呼文字" />
      </Form.Item>

      <Form.Item
        label="联系电话"
        name="phone"
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="二维码"
        name="qrcode"
      >
        <Select options={workerVersions} />
      </Form.Item>
      <Form.Item
        label="引导语1"
        name="followup"
      >
        <Input.TextArea autoSize={{ minRows: 3 }} />
      </Form.Item>
    </Form>
  </Card>
}

export default React.memo(Index);